import { ApiResponse } from '@creator/sdk/creator-sdk';
import { Post } from '@creator/sdk/modules/upvote/upvote.model';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';
import { jotaiStore } from '../store';
// Import new atoms/types, remove old ones
import {
    postsAtom,
    postCollectionFamily,
    PostCollectionCompositeKeyParams
} from './posts';
import reduxStore from '@src/store';
import { getFrontendFunctionsBaseUrl } from '@src/config';

// Interface remains the same
export interface PinPostApiRequestPayload {
    postId: string;
    isPinned: boolean;
    tokenName: string;
    userId: string;
}

// Helper function remains useful
const updatePinnedPostIds = (currentPinnedPostIds: string[], post: Post): string[] => {
    if (post.isPinned) {
        return [post.id, ...currentPinnedPostIds];
    } else {
        // If unpinning, filter it out if it exists.
        return currentPinnedPostIds.filter(id => id !== post.id);
    }
};


export const pinPost = async (payload: PinPostApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();

    const { data } = await postApi<ApiResponse<Post>>('/post/pin', payload, {
        Authorization: `Bearer ${authIdToken}`,
        'X-Firebase-AppCheck': ''
    }, false);

    const post = data.payload; // This is the updated post from the API
    const { tokenName, id: postId } = post;

    jotaiStore.set(postsAtom, draft => {
        // Ensure the post exists in the draft before updating
        if (draft[postId]) {
            // Update the specific post, preserving other properties
            Object.assign(draft[postId], post);
        } else {
            // If for some reason it wasn't loaded, add it
            draft[postId] = post;
        }
    });

    // 2. For Redux compatibility (unchanged)
    reduxStore.getActions().upvote.setPost(post);

    // 3. Determine the target collection parameters
    const params: PostCollectionCompositeKeyParams = {
        type: 'pinned',
        tokenName,
        // No flairId or userId needed for the 'pinned' collection key type
    };

    // 4. Get the specific atom instance for the pinned collection
    const pinnedCollectionAtom = postCollectionFamily(params);

    // 5. Update the pinned collection's state
    jotaiStore.set(pinnedCollectionAtom, draft => {
        draft.ids = updatePinnedPostIds(draft.ids || [], post);
    });

    // 6. Cache invalidation (unchanged)
    const cacheKey = `pinnedPosts_${tokenName}`;
    // Consider error handling for the fetch DELETE request
    fetch(getFrontendFunctionsBaseUrl() + `/cache?key=${cacheKey}`, { method: 'DELETE' })
        .catch(err => console.error(`Failed to invalidate cache for key ${cacheKey}:`, err));

    return post;
};